function generateBranchName() {
  const randomNumber = Math.floor(Math.random() * 1e4);
  const branchName = `veecode-assistant-ai-patch${randomNumber}`;
  return branchName;
}

export { generateBranchName };
//# sourceMappingURL=generateBranchName.esm.js.map
